import { render, staticRenderFns } from "./SuccessOC.vue?vue&type=template&id=48a8524a&scoped=true"
import script from "./SuccessOC.vue?vue&type=script&lang=js"
export * from "./SuccessOC.vue?vue&type=script&lang=js"
import style0 from "./SuccessOC.vue?vue&type=style&index=0&id=48a8524a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a8524a",
  null
  
)

export default component.exports